import React, { useRef } from 'react'
import { Editor } from '@tinymce/tinymce-react'
import { useState } from 'react'
import {
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCol,
  CFormCheck,
  CFormInput,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CRow,
} from '@coreui/react'
import { useDispatch, useSelector } from 'react-redux'
import { addBlog, getBlogs } from 'src/redux/blogs'
import { useEffect } from 'react'
import { toast } from 'react-toastify'
import URL from 'src/apis/URL'
import { isValidJSON } from 'src/utils/function'

const Blogs = () => {
  const editorRef = useRef(null)
  const dispatch = useDispatch()
  const { blogs } = useSelector((state) => state.blogs)

  const [content, setContent] = useState('')
  const [formData, setFormData] = useState({})
  const [aiTitles, setaiTitles] = useState([])
  const [image, setImage] = useState(null)

  const [searchModal, setSearchModal] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [searchResults, setSearchResults] = useState([])

  const handleImageChange = (e) => {
    const file = e.target.files[0]
    setImage(URL.createObjectURL(file))
    setFormData({ ...formData, image: file })
  }

  const handleEditorChange = (content) => {
    setContent(content)
  }

  const fetchAPIsAI = async () => {
    const response = await fetch(URL.AI__URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        prompt: `Mujhe niche diye gaye blog ka title generate karna hai jo SEO-friendly ho. Sirf 5 title ka json array return karo. 
        ["title 1", "title 2", "title 3", "title 4", "title 5"] Blog content: ${editorRef.current.getContent()}`,
      }),
    })
    const output = response.json().then((res) => res.data)
    return output
  }

  const handleTitle = async () => {
    const output = await fetchAPIsAI()
    console.log('Raw Output:', output)
    try {
      const cleanedOutput = output.replace(/```json\n|```/g, '').trim()

      if (!isValidJSON(cleanedOutput)) {
        throw new Error('Invalid JSON format')
      }

      const data = JSON.parse(cleanedOutput)
      setaiTitles(data)
    } catch (error) {
      console.error('Error:', error)
      toast(output, { type: 'error' })
    }
  }

  const handleImage = async () => {
    alert('Comming Soon...')
    const response = await fetch(URL.AI__URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        prompt: `Search google image and give me related image URL for Blog content: ${editorRef.current.getContent()}`,
      }),
    })
    const output = response.json().then((res) => res.data)
    console.log(output)
    return output
  }

  const handleSubmit = async () => {
    if (editorRef.current) {
      console.log(editorRef.current.getContent())
      const body = {
        title: formData?.title,
        image: formData?.image || 'AI IMAGE',
        body: formData?.body || editorRef.current.getContent(),
        data: formData?.data || {
          slug: 'ai-url-title',
          tags: 'AI, URL, SEO',
          meta_title: '',
          meta_description: '',
          meta_keywords: '',
          is_published: false,
          published_at: Date.now(),
        },
      }
      const formDataToSend = new FormData()
      Object.keys(body).forEach((key) => {
        formDataToSend.append(key, body[key])
      })
      try {
        await dispatch(addBlog(body))
        setFormData({})
        setContent('')
        setImage(null)
      } catch (error) {
        toast(error.message, { type: 'error' })
      }
    } else {
      console.log('Blog Content:', content)
    }
  }

  const handleUpdate = () => {}

  const searchImage = () => {}

  const handleSearchImages = async () => {
    if (!searchQuery) {
      toast.error('Enter a search query')
      return
    }

    try {
      const response = await fetch(URL.SEARCH_IMAGE_URL + searchQuery)
      const output = response.json().then((res) => setSearchResults(res.hits || []))
    } catch (error) {
      console.error('Error fetching images:', error)
      toast.error('Failed to fetch images')
    }
  }

  const handleImageSelect = (imgUrl) => {
    setImage(imgUrl)
    setFormData({ ...formData, image: imgUrl })
    setSearchModal(false)
  }

  useEffect(() => {
    dispatch(getBlogs())
  }, [dispatch])

  return (
    <div>
      <Editor
        apiKey="c313olb3g3sytrlyhmvpxol00734zx6jfwa1q8o45nnm6xiu"
        onInit={(_evt, editor) => (editorRef.current = editor)}
        value={content}
        onEditorChange={handleEditorChange}
        init={{
          height: 600, // Increase height to 600px
          menubar: true,
          plugins: [
            // Core editing features
            'anchor',
            'autolink',
            'charmap',
            'codesample',
            'emoticons',
            'image',
            'link',
            'lists',
            'media',
            'searchreplace',
            'table',
            'visualblocks',
            'wordcount',
            // Your account includes a free trial of TinyMCE premium features
            // Try the most popular premium features until Feb 25, 2025:
            'checklist',
            'mediaembed',
            'casechange',
            'export',
            'formatpainter',
            'pageembed',
            'a11ychecker',
            'tinymcespellchecker',
            'permanentpen',
            'powerpaste',
            'advtable',
            'advcode',
            'editimage',
            'advtemplate',
            'ai',
            'mentions',
            'tinycomments',
            'tableofcontents',
            'footnotes',
            'mergetags',
            'autocorrect',
            'typography',
            'inlinecss',
            'markdown',
            'importword',
            'exportword',
            'exportpdf',
          ],
          toolbar:
            'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
          tinycomments_mode: 'embedded',
          tinycomments_author: 'Author name',
          mergetags_list: [
            { value: 'First.Name', title: 'First Name' },
            { value: 'Email', title: 'Email' },
          ],
          ai_request: (request, respondWith) =>
            respondWith.string(() => Promise.reject('See docs to implement AI Assistant')),
        }}
      />
      <div className="">
        <CCol md={12} lg={12} xl={12}>
          <CCard className="my-3">
            <CCardBody className="p-4">
              {aiTitles?.map((title, i) => (
                <CFormCheck
                  key={i}
                  type="radio"
                  name="aiTitles"
                  id={`aiTitle-${i}`}
                  label={title}
                  value={title}
                  checked={formData?.title === title}
                  onChange={() => setFormData({ ...formData, title: title })}
                  className="mb-3"
                />
              ))}
              {aiTitles?.length === 0 ? (
                <CButton color="info" className="px-5 text-white" onClick={handleTitle}>
                  AI Generated Title
                </CButton>
              ) : image === null ? (
                <CButton color="info" className="px-5 text-white" onClick={handleImage}>
                  AI Generated Image
                </CButton>
              ) : (
                <CButton
                  color="success"
                  className="px-5 text-white"
                  onClick={formData?.id ? handleUpdate : handleSubmit}
                >
                  {formData?.id ? 'Update' : 'Submit'}
                </CButton>
              )}
              <CButton
                color="info"
                className="px-5 ms-4 text-white"
                onClick={() => setSearchModal(true)}
              >
                AI Generated Image
              </CButton>
            </CCardBody>
          </CCard>
        </CCol>
      </div>
      {/* Image Search Modal */}
      <CModal size="lg" visible={searchModal} onClose={() => setSearchModal(false)}>
        <CModalHeader closeButton>Search Images</CModalHeader>
        <CModalBody>
          <CRow className="mb-3 justify-content-center">
            <CCol md={8}>
              <CFormInput
                type="text"
                placeholder="Enter search term"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </CCol>
            <CCol md={2}>
              <CButton color="primary" className="px-4" onClick={handleSearchImages}>
                Search
              </CButton>
            </CCol>
          </CRow>

          <div className="image-results">
            {searchResults.length > 0 ? (
              <CRow>
                {searchResults.map((item, index) => (
                  <CCol key={index} md={4} className="mb-3">
                    <img
                      src={item.previewURL}
                      alt={`Result ${index}`}
                      style={{ width: '100%', cursor: 'pointer', borderRadius: '5px' }}
                      onClick={() => handleImageSelect(item.largeImageURL)}
                    />
                  </CCol>
                ))}
              </CRow>
            ) : (
              <p>No images found</p>
            )}
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setSearchModal(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default Blogs
